module.exports = __webpack_public_path__ + "static/media/newbornzone.65841f7d.svg";